import { Outlet } from "react-router-dom";

import { useTranslation } from "@/i18n";
import { SettingsSidebar } from "@/components/settings/settings-sidebar";
import { PageHeader } from "@/components/shared/page-header";

/**
 * Settings page shell. Two-column layout on tablet+: vertical
 * sidebar (60 width) on the left for tab navigation + a flexible
 * main column that hosts the active tab's content via
 * ``<Outlet />``. On mobile the sidebar collapses to a horizontal
 * scrollable strip so the rail never eats half the viewport.
 *
 * The redirect from ``/settings`` to ``/settings/profile`` lives
 * in ``router.tsx`` so this component never has to think about
 * which tab is active — that's the router's job.
 */
export default function SettingsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("settings.page.title")}
        description={t("settings.page.description")}
      />

      <div className="flex flex-col overflow-hidden rounded-lg border border-ocean-100 bg-white tablet:flex-row">
        <SettingsSidebar />
        <main className="flex-1 p-4 tablet:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
